const passengers = {
  table: {
    headers: {
      supplier: 'Flota',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'Flota',
        fields: {
          label: 'Flota Preferida',
        },
      },
    },
  },
};

export default passengers;
